"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var createUrlWithNameId = function createUrlWithNameId(name, id) {
  var nameToDisplay = name ? name.toLowerCase() : "";
  nameToDisplay = nameToDisplay.replace(/ą/g, "a").replace(/ć/g, "c").replace(/ę/g, "e").replace(/ł/g, "l").replace(/ó/g, "o").replace(/ś/g, "s").replace(/ż/g, "z").replace(/ź/g, "z").replace(/,/g, "").replace(/\s/g, "-");
  nameToDisplay = nameToDisplay + "-" + id;
  return nameToDisplay;
};
var _default = createUrlWithNameId;
exports["default"] = _default;